import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import { SinglePlanBT } from '../../../features/planBT/components/PlanBT/SinglePlanBT'
import CreateUpdatePlanBTFormPresenter from '../../../features/planBT/components/PlanBT/CreateUpdatePlanBTForm/CreateUpdatePlanBTFormPresenter'

export default function EditPlanBTPage() {
  return (
    <>
    <HeaderTitleContent withGoBackBtn> <>Modifier Plan BT <SinglePlanBT.Title/></> </HeaderTitleContent>
    <CreateUpdatePlanBTFormPresenter isUpdate />
    </>
  )
}
